import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.css'
})
export class PaginationComponent {

  @Input() currentPage: number = 1;
  @Input() totalPages: number = 1;
  @Input() pageSize: number = 10;
  @Input() totalItems: number = 0;

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  pageSizes: number[] = [5, 10, 25, 50];

  getPages(): number[] {
    const visiblePages = 5;
    const pages: number[] = [];

    // 1. If pages are low, loop normally
    if (this.totalPages <= visiblePages) {
      for (let i = 1; i <= this.totalPages; i++) pages.push(i);
      return pages;
    }

    // 2. Dynamic window boundary calculations
    let startPage = Math.max(1, this.currentPage - Math.floor(visiblePages / 2));
    let endPage = startPage + visiblePages - 1;

    // 3. Prevent right-edge overshoot
    if (endPage > this.totalPages) {
      endPage = this.totalPages;
      startPage = Math.max(1, endPage - visiblePages + 1);
    }

    // 4. Ensure left-edge remains clean if current page is near the end
    if (startPage > 1 && this.currentPage >= this.totalPages - 2) {
      startPage = this.totalPages - visiblePages + 1;
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }

  selectPage(page: number) {
    if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }

  changePageSize(event: any) {
    this.pageSize = +event.target.value;
    this.pageSizeChange.emit(this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }

}
